export { DevicesInfosApi } from './device_infos_api'